/**
 * Flex composite component exports
 *
 * Exports the Flex component, its props interface, variant function,
 * and variant props type for use throughout the application.
 */
export { Flex, type FlexProps } from './Flex';
export {
  flexVariants,
  getFlexChildrenRatioClasses,
  getFlexOverflowClasses,
  FLEX_CHILDREN_RATIO_TOKENS,
  FLEX_OVERFLOW_TOKENS,
  type FlexChildrenRatio,
  type FlexOverflow,
  type FlexVariantProps,
} from './flex.variants';
